import Model from "../_model";

export default class ProductAttributeModel extends Model {
	constructor(provider) {
		super(provider, "product-attributes");
	}

	getAll({ onSuccess, onFail }) {
		return super.filter({ onSuccess, onFail });
	}

	filter({ filter, pager, sorter, onSuccess, onFail }) {
		return super.filter({
			params: {
				text: filter ? filter.text : undefined,
			},
			pager,
			sorter,
			onSuccess,
			onFail,
		});
	}

	find(id, { onSuccess, onFail }) {
		return super.find({ id, onSuccess, onFail });
	}

	getByProduct(productId, { onSuccess, onFail } = {}) {
		return super.filter({ params: { productId }, onSuccess, onFail });
	}

	create(attribute, { onSuccess, onFail }) {
		return super.create(
			{ productId: attribute.productId, name: attribute.name, type: attribute.type, options: attribute.options || [] },
			{ onSuccess, onFail }
		);
	}

	update(attribute, { onSuccess, onFail }) {
		return super.update(
			{
				name: attribute.name,
				type: attribute.type,
				options: attribute.options || [],
			},
			{ id: attribute.id, onSuccess, onFail }
		);
	}

	delete(id, { onSuccess, onFail }) {
		return super.delete({ id, onSuccess, onFail });
	}
}
